"use client";

import { useState } from "react";
import { Dialog, DialogContent, DialogDescription, DialogHeader, DialogTitle, DialogTrigger } from "@/components/ui/dialog";
import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";
import { Label } from "@/components/ui/label";
import { Building2, CreditCard, ArrowRight } from "lucide-react";
import { cn } from "@/lib/utils";

export function FundWalletModal({ children }: { children: React.ReactNode }) {
  const [method, setMethod] = useState<"bank" | "card" | null>(null);
  const [amount, setAmount] = useState("");

  return (
    <Dialog>
      <DialogTrigger asChild>
        {children}
      </DialogTrigger>
      <DialogContent className="sm:max-w-[425px]">
        <DialogHeader>
          <DialogTitle>Fund Your Wallet</DialogTitle>
          <DialogDescription>
            Add money to your PayTaara NGN wallet instantly.
          </DialogDescription>
        </DialogHeader>
        <div className="grid gap-4 py-4">
          <div className="space-y-2">
            <Label htmlFor="amount">Amount to Fund (₦)</Label>
            <Input 
              id="amount" 
              type="number" 
              placeholder="0.00" 
              value={amount}
              onChange={(e) => setAmount(e.target.value)}
            />
          </div>
          <div className="space-y-3">
            <Label>Select Payment Method</Label>
            <div className="grid grid-cols-2 gap-4">
              <button
                type="button"
                onClick={() => setMethod("bank")}
                className={cn(
                  "flex flex-col items-center justify-center p-4 rounded-xl border-2 transition-all",
                  method === "bank" ? "border-primary bg-primary/5" : "border-muted hover:border-primary/50"
                )}
              >
                <Building2 className={cn("h-6 w-6 mb-2", method === "bank" ? "text-primary" : "text-muted-foreground")} />
                <span className="text-sm font-medium">Bank Transfer</span>
              </button>
              <button
                type="button"
                onClick={() => setMethod("card")}
                className={cn(
                  "flex flex-col items-center justify-center p-4 rounded-xl border-2 transition-all",
                  method === "card" ? "border-primary bg-primary/5" : "border-muted hover:border-primary/50"
                )}
              >
                <CreditCard className={cn("h-6 w-6 mb-2", method === "card" ? "text-primary" : "text-muted-foreground")} />
                <span className="text-sm font-medium">Card Payment</span>
              </button>
            </div>
          </div>
          
          {method === "bank" && (
            <div className="bg-muted p-4 rounded-lg mt-2 space-y-2">
              <p className="text-sm font-medium">Transfer to your dedicated account:</p>
              <div className="flex justify-between items-center text-sm">
                <span className="text-muted-foreground">Bank:</span>
                <span className="font-medium">Providus Bank</span>
              </div>
              <div className="flex justify-between items-center text-sm">
                <span className="text-muted-foreground">Account Number:</span>
                <span className="font-mono font-medium">9988776655</span>
              </div>
              <div className="flex justify-between items-center text-sm">
                <span className="text-muted-foreground">Name:</span>
                <span className="font-medium">PayTaara - Your Business</span>
              </div>
            </div>
          )}

          <Button className="w-full mt-4" disabled={!amount || !method}>
            Proceed to Pay <ArrowRight className="ml-2 h-4 w-4" />
          </Button>
        </div>
      </DialogContent>
    </Dialog>
  );
}
